// (function() {
'use strict';

class ItemCarousel {
    constructor() {
        this.$container = $('#vxphl-ld-25-a-header');
        if (!this.$container.length) return;

        this.$carouselWrapper = this.$container.find('.carousel-wrapper');
        this.$items = this.$container.find('.group__box--item');
        this.$btnPrev = $('#carousel-prev');
        this.$btnNext = $('#carousel-next');

        this.itemsPerPage = 6;
        this.currentPage = 0;
        this.totalPages = Math.ceil(this.$items.length / this.itemsPerPage);

        this.init();
    }

    init() {
        this.showPage(this.currentPage);
        this.$btnPrev.on('click', (e) => {
            e.stopPropagation();
            this.prevPage();
        });
        this.$btnNext.on('click', (e) => {
            e.stopPropagation();
            this.nextPage();
        });
    }

    showPage(pageNumber) {
        const start = pageNumber * this.itemsPerPage;
        const end = start + this.itemsPerPage;

        this.$items.each((index, item) => {
            if (index >= start && index < end) {
                $(item).show();
            } else {
                $(item).hide();
            }
        });

        this.currentPage = pageNumber;
    }

    prevPage() {
        if (this.currentPage > 0) {
            this.showPage(this.currentPage - 1);
        }
    }

    nextPage() {
        if (this.currentPage < this.totalPages - 1) {
            this.showPage(this.currentPage + 1);
        }
    }
}

$(window).on('load', function() {
    new ItemCarousel();
});
// })();